import React from 'react';
import _ from 'lodash'
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';
import ToggleButton from '@mui/material/ToggleButton';

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import useGlobalStatus from '../../../hook/useGlobalStatus';
import useColorSystem from '../../../hook/useColorSystem';

import theme from '../../../theme';

import { BoxBorderGrey } from '../../customComponent';

import { excelSheets, allExcelSheets } from '../../../utils/GoogleFieldsDefined'

import { EqualizerIcon } from '../../../constants/images';

const checkExcelSelected = (currentData, originalData) => {
  return currentData.includes(originalData) ? true : false;
}

const GoogleFieldsAllTabs = (props) => {
  const {
    excelSheetSelected,
    reportLanguage,
    setCurrentSheetName,
    setCurrentSheetOrigiName,
    selectedExcelIndex,
    setSelectedExcelIndex,
    setExcelSheetSelected,
    setAllExcelSheetChecked,
    setCurrentSheetSelectFields,
    selectedGeneralFields,
    selectedConversionsFields,
    selectedCustomFields,
    allExcelSheetChecked,
    fieldsBlockHeight,
    setSearchKeyword
  } = props;

  const { locale } = useGlobalStatus();
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const changeAllExcelsheet = (e) => {
    const { checked } = e.target;
    if (checked === true) {
      setAllExcelSheetChecked(true);
      setExcelSheetSelected(allExcelSheets);
    } else {
      setAllExcelSheetChecked(false);
      setExcelSheetSelected([]);
    }
  }

  //頁籤點選按鈕變色
  const handleExcelClick = (e, index) => {
    setSelectedExcelIndex(index);
    setSearchKeyword("");
  };

  //目前頁籤的預選欄位
  const handleDefaultFields = (sheetName) => {
    const currentGeneralFields = selectedGeneralFields.filter((el) =>
      el.sheet.includes(sheetName)
    );

    const currentConversionsFields = selectedConversionsFields.filter((el) =>
      el.sheet.includes(sheetName)
    );

    let currentCustomFields = [];

    if (selectedCustomFields?.length > 0) {
      currentCustomFields = selectedCustomFields.filter((el) =>
        el.sheet.includes(sheetName)
      )
    } else {
      currentCustomFields = [];
    }

    const totalCurrentFields = _.concat(currentGeneralFields, currentConversionsFields, currentCustomFields);
    const sortSheetFields = totalCurrentFields.sort((a, b) => {
      if (a.indexNumber === null) return 1;
      if (b.indexNumber === null) return -1;
      return a.indexNumber - b.indexNumber;
    });

    setCurrentSheetSelectFields(sortSheetFields);
  }

  const changeExcelPage = (e, graphic_name) => {
    const { name, checked } = e.target;

    if (checked) {
      if (graphic_name !== null) {
        setExcelSheetSelected(prev => [...prev, name, graphic_name]);
      } else {
        setExcelSheetSelected(prev => [...prev, name]);
      }

    } else {
      if (graphic_name !== null) {
        setExcelSheetSelected(prev => prev.filter(el => el !== name && el !== graphic_name));
      } else {
        setExcelSheetSelected(prev => prev.filter(el => el !== name));
      }
      setCurrentSheetName('');
    }
  }

  const changeExcelGraphic = (e, sheet) => {
    if (excelSheetSelected.includes(sheet.graphic_name)) {
      setExcelSheetSelected(prev => prev.filter(el => el !== sheet.graphic_name));
      setCurrentSheetName('');
    } else {
      setExcelSheetSelected(prev => [...prev, sheet.graphic_name]);
    }
  }

  return (
    <Box
      sx={{
        flex: 1.2,
        borderRight: `1px solid ${theme.palette.grey.w200}`,
      }}
    >
      <Box
        sx={{
          padding: '16px 0px 12px 30px',
          background: `${theme.palette.grey.w100}`,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 400
          }}
        >
          <FormattedMessage id="createData.tab.title" />
          <Typography
            sx={{
              cursor: 'pointer',
              pr: '14px',
              color: theme.palette.grey.w400,
            }}
          >
            <Checkbox
              size="small"
              name="allCampaign"
              checked={allExcelSheetChecked}
              onChange={changeAllExcelsheet}
              sx={{
                padding: 0,
                color: theme.palette.grey.w400,
                '&.Mui-checked': {
                  color: theme.palette.grey.w400,
                }
              }}
            />
            <FormattedMessage id="common.button.selectAll" />
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          height: fieldsBlockHeight,
          overflow: 'auto',
          background: '#F8F8F8'
        }}
      >
        {excelSheets.filter((item) => item.original_name !== 'Menu')
          .map((el, index) => {
            return (
              <BoxBorderGrey
                key={el.original_name}
                sx={{
                  display: 'inline-block',
                  width: '100%',
                  p: 0,
                }}>
                <List component="div" disablePadding>
                  <ListItem
                    sx={{
                      width: 'auto',
                      padding: 0,
                    }}
                  >
                    <ListItemButton
                      value={el.original_name}
                      selected={selectedExcelIndex === index}
                      onClick={(e) => {
                        setCurrentSheetName(el.name);
                        setCurrentSheetOrigiName(el.original_name);
                        handleExcelClick(e, index);
                        handleDefaultFields(el.original_name);
                      }}
                      sx={{
                        padding: '5px 5px 5px 30px',
                        "&.Mui-selected": {
                          backgroundColor: theme.palette.google.google01
                        }
                      }}
                      disabled={el.selected === false}
                    >
                      <FormControlLabel
                        key={el.original_name}
                        control={
                          <Checkbox
                            size="small"
                            color={colorMedia}
                            name={el.original_name}
                            checked={checkExcelSelected(excelSheetSelected, el.original_name)}
                            onChange={(e) => changeExcelPage(e, el.graphic_name)}
                            disabled={el.selected === false}
                          />
                        }
                        sx={{
                          marginRight: 0,
                          display: el.selected === false
                        }}
                      />
                      <ListItemText
                        id={el.original_name}
                        primary={<FormattedMessage id={el.name} />}
                        sx={{ margin: 0 }}>
                      </ListItemText>
                      {
                        el.graphic_name !== null &&
                        <Tooltip
                          title={
                            <>
                              <FormattedMessage id={el.name} />
                              <FormattedMessage id="createData.tab.chart" />
                            </>
                          }
                          placement="right"
                        >
                          <span>
                            <ToggleButton
                              color="google"
                              value={el.graphic_name}
                              selected={checkExcelSelected(excelSheetSelected, el.graphic_name)}
                              onChange={(e) => changeExcelGraphic(e, el)}
                              disabled={excelSheetSelected.includes(el.original_name) ? false : true}
                              sx={{
                                border: 'none',
                                color: theme.palette.grey.w400,
                                "&:disabled": {
                                  border: 'none'
                                }
                              }}
                            >
                              <EqualizerIcon />
                            </ToggleButton>
                          </span>
                        </Tooltip>
                      }
                    </ListItemButton>
                  </ListItem>
                </List>

              </BoxBorderGrey>
            )
          })
        }
      </Box>
    </Box>
  )
}

export default GoogleFieldsAllTabs;